// bao migrate skip
import * as $ from "jquery";
import * as ko from "knockout";
import * as moment from "moment";
import Bao from "./../../services/bao-service";
// bao migrate - module not found: import Finito from "modules/finito-module";
import BaoMenu from "./../../services/bao-menu";
import TabPage from "./../../factories/tab-page";
import finitoService from "./../../services/finito-service";
import BaoDialog from "./../../factories/bao-dialog";
import Guid from "./../../factories/guid";
import SubscriptionViewModel from "./../../factories/subscription-view-model";
import baoRouter from "./../../services/bao-router";
import "./../../bindings/bao-toolbar2";
import "./../../bindings/filtering";
import AppTabController from "./../../services/app-tab-controller";
import { InfoTemplateDialog } from "../information";
function ShiftReportInformationTab(tabPage, shiftReportViewModel) {
    var self = this;
    SubscriptionViewModel.call(this, tabPage);
    self.TabPage = tabPage;
    self.BaoRouterSubscriptions = [];
    self.Bao = Bao;
    self.IsShiftClosure = ko.observable(false);
    self.ShiftReport = shiftReportViewModel;
    self.ValidDateJs = ko.observable(moment().format(Bao.Utils.DateTimeFormat));
    self.PageSize = ko.observable(10);
    self.PageIndex = ko.observable(0);
    self.Sorting = ko.observableArray();
    self.Selection = ko.observableArray();
    self.CustomFilter = ko.observable({});
    self.SystemSettingNotifyWhenAddEventToClosedReport = ko.observable(false);
    self.Infos = ko.observableArray([]);
    self.TagValues = ko.observableArray([]);
    self.TotalRows = ko.observable(0);
    self.OriginalTabTitle = self.TabPage.Title();
    self.TotalRows.subscribe(function (value) {
        if (value == null || value == 0) {
            self.TabPage.Title(self.OriginalTabTitle);
            return;
        }
        self.TabPage.Title(self.OriginalTabTitle + " (" + value + ")");
    });
    self.toolbarLoaded = function (buttons) {
        self.SetPermissions();
        self.toggleButtons();
    };
    self.PageIndex.subscribe(function () {
        self.getInfos();
    });
    self.PageSize.subscribe(function () {
        self.ResetPageIndexAndRefresh();
    });
    self.ResetPageIndexAndRefresh = function () {
        if (self.PageIndex() === 0) {
            self.getInfos();
        }
        else {
            self.PageIndex(0);
        }
    };
    self.ShowDeletedInfos = ko.observable(false);
    self.ShowDeletedInfos.subscribe(function () {
        self.CustomFilter().IncludeDeleted = self.ShowDeletedInfos();
        self.getInfos();
    });
    self.showShowDeletedCheckboxPermission = ko.observable(false);
    self.showShowDeletedCheckbox = ko.pureComputed(function () {
        return self.showShowDeletedCheckboxPermission() && self.ShiftReport.Permissions() && self.ShiftReport.Permissions()["HasPermissionReportOptionShowDeleted"] && !self.IsShiftClosure();
    });
    self.toolbarButtonClicked = function (btn) {
        if (tabPage != null && tabPage.IsActiveTab != null && tabPage.IsActiveTab() === true) {
            var actionFormName = "action" + self.ShiftReport.FormName() + "CustomToolbarInfo";
            var functionString = btn.ActionKey().substr(actionFormName.length);
            if (functionString && $.isFunction(self[functionString.toLowerCase()])) {
                self[functionString.toLowerCase()]();
            }
        }
    };
    self.returnToMyself = function (tabToClose) {
        if (tabToClose) {
            self.ShiftReport.TabViewModel.RemoveTab(tabToClose);
            self.ShiftReport.TabViewModel.SelectTab(self.TabPage);
        }
    };
    self.link = function (index, infoModel) {
        if (infoModel) {
            self.edit(infoModel.InfoId(), index());
        }
    };
    self.getTagValue = function (tagId, infoId) {
        var tagValues = self.TagValues();
        for (var n = 0; n < tagValues.length; n++) {
            if (tagValues[n].InfoId() === infoId && tagValues[n].TagId() === tagId) {
                return tagValues[n].TagValueHtml();
            }
        }
        return "";
    };
    self.getTagType = function (tagId, infoId) {
        var tagValues = this.TagValues();
        for (var n = 0; n < tagValues.length; n++) {
            if (tagValues[n].InfoId() === infoId && tagValues[n].TagId() === tagId) {
                return tagValues[n].UniversalFieldTypeId();
            }
        }
        return "";
    };
    self.init = function () {
        tabPage.IsLoading(true);
        tabPage.IconLeft("fal fa-dot-circle");
        return Bao.post("Information/GetShowDeletedPermission")
            .then((result) => {
                self.showShowDeletedCheckboxPermission(result);
            });
    };
    self.loaded = function () {
        self.CustomFilter().IsShiftClosure = self.ShiftReport.IsShiftClosure.peek();
        self.BaoRouterSubscriptions.push(baoRouter.routed(function (request, data) {
            self.routeToInfo(request);
        }));
        self.routeToInfo(self.ShiftReport.TabPage);
        Bao.bindEvent("informations:refresh", function (value) {
            if (value.ReportId == self.ShiftReport.ReportId()) {
                self.getInfos();
            }
        });
        self.ValidDateJs.subscribe(function (validDateJs) {
            self.getNavigation(validDateJs);
        });
        tabPage.IsLoading(false);
        self.subscribe(self.ShiftReport.IsOriginal, function (isOriginal) {
            if (isOriginal) {
                self.CustomFilter().IsShiftClosure = false;
                self.ResetPageIndexAndRefresh();
                self.toggleButtons();
            }
        });

        self.subscribe(self.ShiftReport.CurrentRevision, function (CurrentRevision) {
            if (CurrentRevision) {
                self.CustomFilter().IsShiftClosure = false;
                self.ResetPageIndexAndRefresh();
                self.toggleButtons();
            }
        });

        self.subscribe(self.ShiftReport.IsShiftClosure, function (value) {
            if (value) {
                self.CustomFilter().IsShiftClosure = true;
                self.ResetPageIndexAndRefresh();
                self.toggleButtons();
            }
        });

        self.subscribe(self.Sorting, function () {
            self.resetSearchPaging();
            self.getInfos();
        });
        self.subscribe(self.CustomFilter, function () {
            self.resetSearchPaging();
            self.ResetPageIndexAndRefresh();
        });
        self.subscribe(self.Selection, function (selection) {
            self.toggleButtons();
        });
    };
    self.dispose = function () {
        ko.utils.arrayForEach(self.BaoRouterSubscriptions, function (subscription) {
            baoRouter.unsubscribe(subscription);
        });
        ko.utils.arrayForEach(self.Subscriptions, function (subscription: any) {
            subscription.dispose();
        });
    };
    self.ToHashObject = function (customFilter) {
        var returnValue = [];
        for (var f in customFilter) {
            returnValue.push({
                Key: f,
                Value: ko.unwrap(customFilter[f])
            });
        }
        return returnValue;
    };
}
;
Bao.inherit(ShiftReportInformationTab, SubscriptionViewModel);
ShiftReportInformationTab.prototype.removeInfoIdFromRoute = function () {
    var currentHash = baoRouter.getHash(), infoIdIndex = currentHash.toLowerCase().indexOf('info');
    if (infoIdIndex !== -1) {
        baoRouter.replaceHash(currentHash.substr(0, infoIdIndex));
    }
};
ShiftReportInformationTab.prototype.routeToInfo = function (tabPage) {
    var infoId = baoRouter.getRouteValue("infoid", tabPage);
    if (this.TabPage.IsActiveTab() || infoId) {
        var reportId = baoRouter.getRouteValue("id", tabPage);
        if (reportId === this.ShiftReport.ReportId() && infoId) {
            this.removeInfoIdFromRoute();
            var activeInfoTab = this.ShiftReport.TabViewModel.SearchTabByObjectId("ActiveInfo");
            var index = null, i = 0, ignoreIndex = true;
            ko.utils.arrayForEach(this.Infos(), function (item: any) {
                if (item.InfoId() == infoId) {
                    ignoreIndex = false;
                    index = i;
                }
                i++;
            });
            if (activeInfoTab) {
                if (ko.isObservable(activeInfoTab.ViewModel)) {
                    var infoViewModel = activeInfoTab.ViewModel();
                    if (infoViewModel) {
                        if (infoViewModel.InfoId() === infoId) {
                            this.ShiftReport.TabViewModel.SelectTab(infoViewModel.TabPage);
                        }
                        else {
                            this.edit(infoId, index, ignoreIndex);
                        }
                    }
                }
            }
            else {
                this.edit(infoId, index, ignoreIndex);
            }
        }
    }
};
ShiftReportInformationTab.prototype.resetSearchPaging = function () {
    var activeInfoTab = this.ShiftReport.TabViewModel.SearchTabByObjectId("ActiveInfo");
    if (activeInfoTab) {
        activeInfoTab.ViewModel().disablePaging();
    }
};
ShiftReportInformationTab.prototype.getInfos = function () {
    let self = this;
    self.TabPage.IsLoading(true);
    let customFilter = self.ToHashObject(ko.unwrap(self.CustomFilter));    
    let isOriginal = self.ShiftReport.IsOriginal.peek()
    let isShiftClosure = self.ShiftReport.IsShiftClosure.peek()    
    self.IsShiftClosure(isShiftClosure)
    return Bao.post("Information/GetAll", JSON.stringify({
        id: self.TabPage.FormHistoryId,
        reportId: self.ShiftReport.ReportId(),
        searchFilter: {
            IsOriginal: isOriginal
        },
        pageIndex: self.PageIndex(),
        pageSize: self.PageSize(),
        sorting: self.Sorting(),
        customfilter: customFilter
    })).then(function (result) {
        ko.map.fromJS(result, self);
        if (self.Infos != undefined) {
            ko.utils.arrayForEach(self.Infos(), function (item: any) {
                if (!item.IsStrikeThrough()) {
                    item.ShowDeletedInfosStyle("none");
                }
                else {
                    item.ShowDeletedInfosStyle("line-through");
                }
            });
        }
        self.TabPage.IsLoading(false);
    });
};
ShiftReportInformationTab.prototype.toggleButtons = function () {
    var self = this;
    var prefix = "action" + self.ShiftReport.FormName() + "CustomToolbarInfo";
    var hasSelection = self.Selection().length > 0;
    const isNotDeleted = hasSelection ? !self.Selection()[0].DeleteDate() : true;
    self.enableButton(prefix + "New", self.ShiftReport.IsValid.peek() && !self.ShiftReport.IsOriginal.peek() && !self.ShiftReport.IsShiftClosure.peek());
    self.enableButton(prefix + "Edit", self.ShiftReport.IsValid.peek() && !self.ShiftReport.IsOriginal.peek() && !self.ShiftReport.IsShiftClosure.peek() && isNotDeleted && hasSelection);
    self.enableButton(prefix + "Copy", self.ShiftReport.IsValid.peek() && !self.ShiftReport.IsOriginal.peek() && !self.ShiftReport.IsShiftClosure.peek() && isNotDeleted && hasSelection);
    self.enableButton(prefix + 'CopyOrTransfer', self.ShiftReport.IsValid.peek() && !self.ShiftReport.IsOriginal.peek() && !self.ShiftReport.IsShiftClosure.peek() && isNotDeleted && hasSelection);
    self.enableButton(prefix + 'BlindCopyNextShift', self.ShiftReport.IsValid.peek() && !self.ShiftReport.IsOriginal.peek() && !self.ShiftReport.IsShiftClosure.peek() && isNotDeleted && hasSelection);
    self.enableButton(prefix + 'BlindCopyCurrentShift', self.ShiftReport.IsValid.peek() && !self.ShiftReport.IsOriginal.peek() && !self.ShiftReport.IsShiftClosure.peek() && isNotDeleted && hasSelection);
    self.enableButton(prefix + 'ReferCurrentShift', self.ShiftReport.IsValid.peek() && !self.ShiftReport.IsOriginal.peek() && !self.ShiftReport.IsShiftClosure.peek() && isNotDeleted && hasSelection);
    self.enableButton(prefix + 'ReferNextShift', self.ShiftReport.IsValid.peek() && !self.ShiftReport.IsOriginal.peek() && !self.ShiftReport.IsShiftClosure.peek() && isNotDeleted && hasSelection);
    self.enableButton(prefix + "CreateNotification", self.ShiftReport.IsValid.peek() && !self.ShiftReport.IsOriginal.peek() && !self.ShiftReport.IsShiftClosure.peek() && isNotDeleted && hasSelection);
    self.enableButton(prefix + "CreateChecklist", self.ShiftReport.IsValid.peek() && !self.ShiftReport.IsOriginal.peek() && !self.ShiftReport.IsShiftClosure.peek() && isNotDeleted && hasSelection);
    self.enableButton(prefix + "CreateTicket", self.ShiftReport.IsValid.peek() && !self.ShiftReport.IsOriginal.peek() && !self.ShiftReport.IsShiftClosure.peek() && isNotDeleted && hasSelection);
    self.enableButton(prefix + "Delete", self.ShiftReport.IsValid.peek() && !self.ShiftReport.IsOriginal.peek() && !self.ShiftReport.IsShiftClosure.peek() && isNotDeleted && hasSelection);
};
ShiftReportInformationTab.prototype.SetPermissions = function () {
    var self = this;
    var permissions = self.ShiftReport.Permissions();
    if (!permissions)
        return;
    for (var actionKey in permissions) {
        self.boaToolbar2ShowButton(actionKey, permissions[actionKey]);
    }
};
ShiftReportInformationTab.prototype.createNewInfoTab = function (newInfo: boolean) {
    var self = this;
    var newTab = self.ShiftReport.TabViewModel.SearchTabByObjectId("ActiveInfo");
    if (!newTab) {
        newTab = new TabPage("ActiveInfo");
        newTab.AutoSelect = false;
        newTab.Url("Information/Detail");
        newTab.UrlData({
            id: self.TabPage.FormHistoryId,
            reportId: self.ShiftReport.ReportId(),
            shiftbookId: this.ShiftReport.ShiftbookId()
        });
        newTab.IsClosable(true);
        newTab.PreLoad(true);
        newTab.Visible(true);
        newTab.FormHistoryId = self.TabPage.FormHistoryId;
        newTab.InformationTab = self;
        newTab.AlreadyLoaded = false;
        if (!newInfo) {
            self.ShiftReport.TabViewModel.AddTab(newTab);
        }
    }
    return newTab;
};
ShiftReportInformationTab.prototype.getInfoTab = function () {
    return this.ShiftReport.TabViewModel.SearchTabByObjectId("ActiveInfo");
};
ShiftReportInformationTab.prototype["new"] = function () {
    var self = this;
    if ((!self.SystemSettingNotifyWhenAddEventToClosedReport() || self.ShiftReport.IsClosed() !== true) && self.ShiftReport?.Permissions()?.actionFormShiftReportCustomToolbarActiveInfoNew) {

        self.OpenNewShiftEvent();
        return;
    }
    var yesnodialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage(finitoService.MessageKeys.AddEventToClosedReport), "yesno");
    yesnodialog.DialogResult.subscribe(function (dialogresult) {
        if (dialogresult && self.ShiftReport?.Permissions()?.actionFormShiftReportCustomToolbarActiveInfoNew) {
            self.OpenNewShiftEvent();
            return;
        }
    });
};
ShiftReportInformationTab.prototype.OpenNewShiftEvent = function () {
    var self = this;
    var infoTab = this.createNewInfoTab(true);
    if (infoTab) {
        self.CreateInfoTemplateDialog()
            .then(infoTemplateId => {
                self.ShiftReport.TabViewModel.AddTab(infoTab);
                var newInfoId = Guid();
                infoTab.InfoId = newInfoId;
                infoTab.InfoTemplateId = infoTemplateId;
                infoTab.IsNew = true;
                this.loadTab(infoTab, true, newInfoId, null);
            });
    }
};

ShiftReportInformationTab.prototype.CreateInfoTemplateDialog = function () {
    var self = this;
    let def = $.Deferred();
    self.TabPage.IsLoading(true);
    let infoTemplateDialog = new InfoTemplateDialog(self.TabPage);
    infoTemplateDialog.OpenDialog(self.ShiftReport.ShiftbookId())
        .then((infoTemplate: any) => {
            let infoTemplateId = null;
            if (infoTemplate != null) {
                if (infoTemplate !== false) {
                    infoTemplateId = infoTemplate.InfoTemplateId;
                }
                def.resolve(infoTemplateId);
            }
            else {
                def.reject();
            }
        });
    return def.promise();
}

ShiftReportInformationTab.prototype.GetInfoForPaging = function (index) {
    var self = this;
    var def = $.Deferred();
    var indexFrom = self.PageIndex() * self.PageSize();
    var indexTo = indexFrom + self.PageSize() - 1;
    if (index >= indexFrom && index <= indexTo) {
        var currentRowIndex = index - self.PageIndex() * self.PageSize();
        def.resolve(self.Infos()[currentRowIndex]);
    }
    else {
        var customFilter = self.ToHashObject(ko.unwrap(self.CustomFilter));
        Bao.post("Information/GetAll", JSON.stringify({
            id: self.TabPage.FormHistoryId,
            reportId: self.ShiftReport.ReportId(),
            searchFilter: {
                IsOriginal: self.ShiftReport.IsOriginal.peek()
            },
            pageIndex: index,
            pageSize: 1,
            sorting: self.Sorting(),
            customfilter: customFilter
        }), function (searchResult) {
            if (searchResult != null && searchResult.Infos != null) {
                def.resolve(searchResult.Infos[0]);
            }
            else {
                def.resolve(null);
            }
        });
    }
    return def.promise();
};
/**
 * set the index if infoid is matched into the  infos array  
 * * */
ShiftReportInformationTab.prototype.GetIndexByInfoId = function (infoId, index) {
    var self = this;
    if (index == null) {
        var i = 0;
        ko.utils.arrayForEach(self.Infos(), function (item: any) {
            if (item.InfoId() == infoId) {
                index = i;
            }
            i++;
        });

    }
    return index;

}
ShiftReportInformationTab.prototype.edit = function (infoId, index, ignoreIndex) {
    var self = this;
    if (infoId == null || index == null && ignoreIndex == false) {
        if (self.Selection().length > 0) {
            if (infoId == null) {
                infoId = self.Selection()[0].InfoId();
            }

            index = self.GetIndexByInfoId(infoId, index);

        }
        else {
            return;
        }
    }
    if (index != null) {
        index = index + self.PageIndex() * self.PageSize();
    }
    var tabAlreadyOpened = this.ShiftReport.TabViewModel.SearchTabByObjectId("ActiveInfo") != null;

    var infoTab = self.createNewInfoTab(false);
    if (infoTab) {
        if (tabAlreadyOpened == false) {
            infoTab.IsNew = false;
            infoTab.InfoId = infoId;
            infoTab.ListIndex = index;
        }
        self.loadTab(infoTab, false, infoId, index);
    }

};
ShiftReportInformationTab.prototype.loadTab = function (tab, isNew, infoId, listIndex) {
    var self = this;
    self.ShiftReport.TabViewModel.SelectTab(tab);
    if (tab.AlreadyLoaded) {
        var tabViewModel = tab.ViewModel();
        tabViewModel.BeforeClose(function () {
            tab.IsNew = isNew;
            tab.InfoId = infoId;
            tab.ListIndex = listIndex;
            tabViewModel.init().then(tabViewModel.loaded).then(function () {
                tabViewModel.PagingEnabled(true);
                self.ShiftReport.TabViewModel.SelectTab(tabViewModel.TabPage);
                tabViewModel.toggleButtons();
                tabViewModel.setTabTitle();
            });
        }, true);
    }
    else { }
};
ShiftReportInformationTab.prototype.copy = function () { };
// Function for copying or refering shift events
// method (BlindCopy or TransferCopy)
// data (IDs that should be sent to the backend)
// url (Endpoint name)
// type (Current or next)
ShiftReportInformationTab.prototype.copyreferinfo = function (method, data, url, type) {
    var self = this;
    var selection = self.Selection();
    if (selection.length > 0) {
        let dialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage('Info' + method + type + 'Question'), 'yesno');
        dialog.DialogResult.subscribe(function (canCopy) {
            if (canCopy) {
                self.TabPage.IsLoading(true);
                var infoIds = ko.utils.arrayMap(selection, function (i: any) {
                    return i.InfoId();
                });

                Bao.post('Information/' + url, JSON.stringify({
                    id: self.TabPage.FormHistoryId,
                    infoIds: infoIds,
                    ...data
                })).then(function (copied) {
                    self.Selection([]);
                    if (copied) {
                        self.showAlert('Info' + method + type + 'Successful');
                    } else {
                        self.showAlert('Info' + method + type + 'Error', 'danger');
                    }
                    self.getInfos();
                    self.TabPage.IsLoading(false);
                });
            }
        });
    }
};


// Copy to next shift
ShiftReportInformationTab.prototype.blindcopynextshift = function () {
    var self = this;
    self.copyreferinfo(
        'BlindCopy',
        { reportId: self.ShiftReport.ReportId() },
        'BlindCopy',
        ''
    );
};
// Copy to current shift
ShiftReportInformationTab.prototype.blindcopycurrentshift = function () {
    var self = this;
    self.copyreferinfo(
        'BlindCopy',
        { shiftbookId: self.ShiftReport.ShiftbookId() },
        'BlindCopyToCurrent',
        'Current'
    );
};
// Refer to current shift
ShiftReportInformationTab.prototype.refercurrentshift = function () {
    var self = this;
    self.copyreferinfo(
        'TransferCopy',
        {
            shiftbookId: self.ShiftReport.ShiftbookId(),
            openReportId: self.ShiftReport.ReportId()
        },
        'TransferCopyToCurrent',
        'Current'
    );
};
// Refer to next shift
ShiftReportInformationTab.prototype.refernextshift = function () {
    var self = this;
    self.copyreferinfo(
        'TransferCopy',
        { reportId: self.ShiftReport.ReportId() },
        'TransferCopy',
        ''
    );
};

ShiftReportInformationTab.prototype["delete"] = function () {
    var self = this;
    var selection = self.Selection();
    if (selection.length > 0) {
        var dialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage(finitoService.MessageKeys.InfoDeleteQuestion), "yesno");
        dialog.DialogResult.subscribe(function (canDelete) {
            if (canDelete) {
                self.TabPage.IsLoading(true);
                var infoIds = ko.utils.arrayMap(selection, function (i: any) {
                    return i.InfoId();
                });
                Bao.post("Information/Delete", JSON.stringify({
                    id: self.TabPage.FormHistoryId,
                    reportId: self.ShiftReport.ReportId(),
                    infoIds: infoIds
                })).then(function (deleted) {
                    self.Selection([]);
                    if (deleted > 0) {
                        var infoTab = self.getInfoTab();
                        if (infoTab) {
                            if (infoTab.ViewModel().InfoId() == infoIds[0]) {
                                self.ShiftReport.TabViewModel.RemoveTab(infoTab);
                            }
                        }
                        self.showAlert(finitoService.MessageKeys.InfoDeleteSuccessful);
                    }
                    else {
                        self.showAlert(finitoService.MessageKeys.InfoDeleteError, "danger");
                    }
                    self.getInfos();
                    self.TabPage.IsLoading(false);
                });
            }
        });
    }
};
ShiftReportInformationTab.prototype.createnotification = function () {
    var self = this;
    var selection = self.Selection();
    if (selection.length > 0) {
        self.TabPage.IsLoading(true);
        var infoId = self.Selection()[0].InfoId();
        var notifCreated = false;
        return Bao.post("Information/CheckInfoSap", JSON.stringify({
            infoId: infoId
        }), function (result) {
            notifCreated = result.Message;
            if (!notifCreated) {
                window.baorequire(["ViewModels/Dialogs/InfoSapDialog"], function (vm) {
                    var dialog;
                    if (infoId != null) {
                        dialog = new vm(self.TabPage);
                        dialog.Show(infoId, self.TabPage);
                        self.TabPage.IsLoading(false);
                    }
                });
            }
            else {
                var baoDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgSapExist"), "info");
            }
            self.TabPage.IsLoading(false);
        });
    }
};
ShiftReportInformationTab.prototype.createchecklist = function () {
    var self = this;
    var selection = self.Selection();
    if (selection.length > 0) {
        self.ReportViewModel = self.ShiftReport;
        var count = 0;
        return Bao.post("Dialog/GetInfoChecklistsByShiftbookId", JSON.stringify({
            shiftbookId: self.ReportViewModel.ShiftbookId()
        }), function (result) {
            if (result != null) {
                count = result.length;
            }
            if (count === 1) {
                self.CreateEvaluation(result[0], self.ReportViewModel.ReportId());
            }
            else {
                window.baorequire(["ViewModels/Dialogs/CreateEvaluationDialog"], function (vm) {
                    var dialog = new vm(self.TabPage, self);
                    dialog.Show();
                    dialog.DialogResult.subscribe(function (dialogResult) {
                        if (dialogResult == true) {
                            self.CreateEvaluation(dialog.DialogViewModel.FolderStructureChecklistId(), self.ReportViewModel.ReportId());
                        }
                    });
                });
            }
        });
    }
};
ShiftReportInformationTab.prototype.CreateEvaluation = function (folderStructureChecklistId, reportId) {
    var self = this;
    self.TabPage.IsLoading(true);
    var infoId = self.Selection()[0].InfoId();
    return Bao.post("EvaluationTab/CreateEvaluationByReport", JSON.stringify({
        folderStructureChecklistId: folderStructureChecklistId,
        reportId: reportId,
        infoId: infoId
    }), function (result) {
        if (result != false) {
            baoRouter.setHash("checkware/evaluation/" + result);
        }
        self.TabPage.IsLoading(false);
    });
};
ShiftReportInformationTab.prototype.createticket = function () {
    var self = this;
    var AppTabController = window.baorequire("Services/AppTabController");
    var selection = self.Selection();
    if (selection.length > 0) {
        var infoId = self.Selection()[0].InfoId();
        Bao.post("Information/GetInformation", JSON.stringify({
            reportId: self.ShiftReport.ReportId(),
            infoId: infoId,
            isOriginal: false
        }), function (result) {
            let newTicketTab = new TabPage("NewTicket");
            newTicketTab.IsClosable(true);
            newTicketTab.AutoSelect = true;
            newTicketTab.PreLoad(true);
            newTicketTab.Visible(true);
            newTicketTab.Url("Ticket/Index");
            newTicketTab.UrlData({
                infoId: result.InfoId,
                problemText: result.InfoText
            });
            AppTabController.AddTab(newTicketTab);
        });
    }
    ;
};
export default ShiftReportInformationTab;